//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('oeeStateEquipment', {
//        templateUrl: 'views/components/views/oeeStateEquipment/oeeStateEquipment.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'oeeStateEquipmentService', function ($stateParams, stateService, oeeStateEquipmentService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let oeeStateEquipmentKeyno = $stateParams.oeestate_equipment_keyno;

//            vm.model = {
//                edit: {},
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALL

//            async function loadEdit() {
//                vm.model.edit = (await oeeStateEquipmentService.getEdit({ oeestate_equipment_keyno: oeeStateEquipmentKeyno }))[0];
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALL

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                oeeStateEquipmentService.saveObj(vm.model.edit).then(function () {
//                    vm.model.lockedSave = false;
//                    stateService.back();
//                }, function () {
//                    vm.model.lockedSave = false;
//                });
//            };

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadEdit();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
